import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  comeFromSettingPage: null,
  showStripeSuccessPopUp: false,
};

export const paymentSlice = createSlice({
  name: "paymentSlice",
  initialState,
  reducers: {
    setComeFromPage: (state, action) => {
      state.comeFromSettingPage = action.payload;
    },
    setStripeSuccessPopUp: (state, action) => {
      state.showStripeSuccessPopUp = action.payload;
    },
  },
});

export const { setComeFromPage, setStripeSuccessPopUp } = paymentSlice.actions;

export default paymentSlice.reducer;
